export const ErrorBlock = ({ error }: { error?: string | string[] }) =>
  error ? (
    <div className="input-error-message">
      {Array.isArray(error) ? error[0] : error}
    </div>
  ) : null
